
define('app/dashboard/leagues/instances/views/fantTeamAddView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/leagueUserModel',
	'known/models/fantasyTeamModel',
	'known/models/productTypeModel'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		LeagueUserModel,
		FantasyTeamModel,
		ProductTypeModel){

	var AddTeamFooterView = Backbone.View.extend({
		events: {
			'click #addTmFormSubmit': 'submitAddTeamForm',
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showAddForm();
			
			this.listenTo(this.event, 'default', this.showAddForm);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.showAddForm);
			this.listenTo(this.event, 'success', this.showAddForm);
		},
		
		hideAll: function () {
			this.$("#addTmFormSubmit").hide();
			this.$("#addTmFormCancel").hide();
		},
		
		submitAddTeamForm: function () {
			this.event.trigger("save");
		},
		
		showAddForm: function () {
			this.hideAll();
			this.$("#addTmFormSubmit").show();
			this.$("#addTmFormCancel").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var AddTeamContentView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			this.submittedData = options.submittedData;
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.prodType = options.prodType;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			
			this.listenTo(this.event, 'save', this.submitAddTeam);
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.addTeamForm);
			this.listenTo(this.event, 'success', this.success);
			
			//Error handling
			this.listenTo(this.event, 'error:teamname', this.errorTeamName);
			
			//Initialize fields
			this.$("#addTmNameInput").val("");
		},
		
		submitAddTeam: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				this.submittedData.isSubmitted = true;
				var addedTeam = new FantasyTeamModel({
					teamName: this.$("#addTmNameInput").val(),
					leagueUserId: this.lgInstance.getCommisssionerUser().get("id")
				},{
					lgInstId: this.lgInstance.get('id'),
					lgId: this.lgInstance.get('leagueId')});
				addedTeam.save({}, {wait: true, success: this.successCallback, error: this.errorCallback});
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			//Hide error messages
			this.$("#addTmNameInput").removeClass("error");
			this.$("#addTmNameErrMsg").hide();
		},
		
		addTeamForm: function () {
			this.hideAll();
			$(this.el).show();
		},
		
		success: function () {
			this.hideAll();
			this.$("#addTmNameInput").val("");
		},
		
		errorTeamName : function (errorCode) {
			this.$("#addTmNameInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#addTmNameErrMsg").html("Team name is empty");
					this.$("#addTmNameErrMsg").show();
					break;
				case "LENGTH":
					this.$("#addTmNameErrMsg").html("Team name must be between 2 and 20 characters long");
					this.$("#addTmNameErrMsg").show();
					break;
				case "ALPHANUMSPACE":
					this.$("#addTmNameErrMsg").html("Team name may only contain alpha numeric characters and spaces");
					this.$("#addTmNameErrMsg").show();
					break;
				default : 
					this.$("#addTmNameErrMsg").html("Team name is invalid");
					this.$("#addTmNameErrMsg").show();
			}
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var AddTeamMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'resetMessages', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.addSuccess);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$("#addTmBodyMessageError").hide();
			this.$("#addTmBodyMessageProcessing").hide();
			this.$("#addTmBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#addTmBodyMessageError").show();
		},
		
		addSuccess: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#addTmBodyMessageSuccess").show();
			this.$("#addTmBodyMessageSuccess").fadeOut(3000);
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#addTmBodyMessageProcessing").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var AddTeamView = Backbone.View.extend({
		el: $("#addTmContent"),
		
		initialize: function(options) {
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.prodType = options.prodType;
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'hideView');
			_.bindAll(this, 'showView');
			_.bindAll(this, 'formSubmit');
			
			this.message = new AddTeamMessageView({el: this.$("#addTmBodyMessage"), event: this.event});
			this.content = new AddTeamContentView({
					el: this.$("#addTmBodyContent"), 
					event: this.event,
					submittedData : this.submittedData,
					userModel: this.userModel, 
					lgInstance: this.lgInstance,
					prodType: this.prodType});
			this.footer = new AddTeamFooterView({el: this.$("#addTmFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.success);
			this.listenTo(this.event, 'savingError', this.error);
			
			this.listenTo(this.lgInstance, 'change:draftStatus', this.updateVisuals);
			
			//Setup Form open/hide
			var addTmOpenBtn = this.$("#addTmOpen");
			var addTmCloseBtn = this.$("#addTmFormCancel");
			
			addTmOpenBtn.on('click', {}, this.showView);
			addTmCloseBtn.on('click', {}, this.hideView);
			this.$("#addTmBodyContent").submit(this.formSubmit);
		},
		
		render: function () {
			this.event.trigger("default");
			this.updateVisuals();
			return this;
		},
		
		updateVisuals: function() {
			//Determine whether to show the Remove Team form button
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) 
					&& this.lgInstance.get("draftStatus") == "SETUP"
					&& this.prodType.get('active')){
				this.$("#addTmOpen").show();
			} else {
				this.$("#addTmOpen").hide();
			}
		},
		
		hideView: function() {
			this.event.trigger("resetMessages");
			this.$("#addTmOpen").show();
			this.$("#addTmBodyContent").slideUp();
		},
		
		showView: function() {
			this.$("#addTmOpen").hide();
			this.$("#addTmBodyContent").slideDown();
		},
		
		error: function(model, error) {
			if(this.submittedData.isSubmitted){
				model.destroy();
				
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		success: function (model, response) {			
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				//this.model.trigger("reset");
				this.lgInstance.get('fantasyTeams').add(model);
				this.event.trigger("success");
			}

			this.$("#addTmOpen").show();
			this.$("#addTmBodyContent").hide();
		},
		
		formSubmit: function(e) {
			e.preventDefault();
			return false;
		},
		
		destroyView: function() {
	    	this.message.destroyView();
			this.content.destroyView();
			this.footer.destroyView();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	return AddTeamView;  
});